<template>
  <div v-if="availableSlots.length > 0" class="available-slots-modern">
    <h4 class="slots-title">{{ $t("experiences.availableSlots") }}</h4>
    <div class="slots-grid">
      <SlotCard
        v-for="slot in availableSlots"
        :key="slot.id"
        :slot="slot"
        :showPrice="showPrices"
        :priceType="priceType"
        @select="$emit('select-slot', $event)"
      />
    </div>

    <!-- Next Available Dates - Show when all slots are unavailable -->
    <NextAvailableSlots
      v-if="nextAvailableSlots.length > 0"
      :slots="nextAvailableSlots"
      :showPrice="showPrices"
      :priceType="priceType"
      @select="$emit('select-slot', $event)"
    />
  </div>
</template>

<script>
import SlotCard from './SlotCard.vue';
import NextAvailableSlots from './NextAvailableSlots.vue';

export default {
  name: 'SlotsDisplay',
  components: {
    SlotCard,
    NextAvailableSlots
  },
  props: {
    availableSlots: {
      type: Array,
      required: true
    },
    nextAvailableSlots: {
      type: Array,
      default: () => []
    },
    showPrices: {
      type: Boolean,
      default: false
    },
    priceType: {
      type: String,
      default: 'PerExperience'
    }
  }
};
</script>

<style scoped>
.available-slots-modern {
  margin-top: 3rem;
  padding-top: 2.5rem;
  border-top: 2px solid #f3f4f6;
}

.slots-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--secondary-color);
  margin: 0 0 1.5rem 0;
  text-align: center;
}

.slots-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1.25rem;
}

@media (max-width: 768px) {
  .slots-grid {
    grid-template-columns: 1fr;
  }
}
</style>
